import { type PayoutCascade } from '~/entities/payout';
import { protobufDurationToTime, timeToProtobufDuration } from '~/shared/lib/date-time';
import { type PayoutCommonCascadeV1Filter } from '~/generated/payoutBackend/model';
import { type CascadeEditorFormValues } from './types';

export const initialFormValues: CascadeEditorFormValues = {
    name: '',
    minAmount: 0,
    maxAmount: 0,
    currency: undefined,
    requisiteType: undefined,
    startAt: '',
    endAt: '',
};

export const cascadeToFormValues = (cascade: PayoutCascade): CascadeEditorFormValues => ({
    name: cascade.name?.value ?? '',
    minAmount: Number(cascade.filter?.minAmount?.value ?? 0),
    maxAmount: Number(cascade.filter?.maxAmount?.value ?? 0),
    currency: cascade.filter?.currency,
    requisiteType: cascade.filter?.requisiteType,
    startAt: protobufDurationToTime(cascade.filter?.startAt) ?? '',
    endAt: protobufDurationToTime(cascade.filter?.endAt) ?? '',
});

export const formValuesToFilter = (values: CascadeEditorFormValues): PayoutCommonCascadeV1Filter => ({
    currency: values.currency,
    requisiteType: values.requisiteType,
    minAmount: { value: String(values.minAmount) },
    maxAmount: { value: String(values.maxAmount) },
    startAt: timeToProtobufDuration(values.startAt),
    endAt: timeToProtobufDuration(values.endAt),
});
